//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    props: ['account', 'depth', 'category', 'categories'],
    data: function data() {
        return {
            accountSelected: null,
            accountData: {},
            allAccounts: {},
            loading: false,
            parentAccount: {
                id: '',
                display: ''
            },
            accountCategory: {
                id: 0,
                display: String
            }
        };
    },
    mounted: function mounted() {
        SelectedProperty = 1;

        this.accountCategory = {
            id: this.categories[this.category].id,
            display: this.categories[this.category].number + ' - ' + this.categories[this.category].name
        };
    },
    created: function created() {
        var $el = this;
        Event.$on('clear-selected', function () {
            $el.loading = false;
            $el.accountSelected = null;
        });

        Event.$on('set-accounts', function (accounts) {
            $el.allAccounts = accounts;
            console.log('got set');
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('clear-selected');
        Event.$off('set-accounts');
    },


    methods: {
        closeAccount: function closeAccount() {
            Event.$emit('clear-selected');
            this.accountData = {};
        },
        editAccount: function editAccount(account) {
            Event.$emit('clear-selected');
            Event.$emit('get-accounts', this.category);
            this.accountSelected = account.id;
            var $el = this;

            // if it does have a parent, find and associate
            if (account.parent_id !== 0 && this.allAccounts.length) {
                var parent = this.allAccounts.find(function (all) {
                    return account.parent_id == all.id;
                });
                this.parentAccount = {
                    id: parent.id,
                    display: parent.number + ' - ' + parent.name
                };
            } else {
                this.parentAccount = {
                    id: 0,
                    display: 'No Parent'
                };
            }

            axios.get('/prototype/accounting/general-ledger/chart-of-accounts/account/' + account.id).then(function (response) {
                $el.accountData = response.data;
                $el.accountData.starting_balance = $el.accountData.starting_balance > 0 ? $el.accountData.starting_balance : 0;
            });
        },
        moveRight: function moveRight(account) {

            var $el = this;
            var idx = 0;
            Event.$emit('get-accounts', this.category);

            if (this.allAccounts.length) {
                // find account in array
                idx = this.allAccounts.map(function (all) {
                    return all.id;
                }).indexOf(account.id);
            }

            // find closest sibling
            var sibling = this.allAccounts[idx - 1];

            if (sibling.parent_id !== 0 && sibling.parent_id !== account.parent_id && this.allAccounts.length) {
                // find sibling parent
                var parent = this.allAccounts.find(function (all) {
                    return sibling.parent_id === all.id;
                });
            } else {
                var parent = sibling;
            }

            account.parent_id = parent.id;

            axios.post('/prototype/accounting/general-ledger/chart-of-accounts/account/parent', { account: account.id, parent: account.parent_id }).then(function () {
                Event.$emit('refresh-gl-accounts');
            });
        },
        moveLeft: function moveLeft(account) {
            Event.$emit('get-accounts', this.category);

            if (this.allAccounts.length) {
                // find parent
                var parent = this.allAccounts.find(function (all) {
                    return account.parent_id === all.id;
                });
                account.parent_id = parent.parent_id;

                axios.post('/prototype/accounting/general-ledger/chart-of-accounts/account/parent', { account: account.id, parent: account.parent_id }).then(function () {
                    Event.$emit('refresh-gl-accounts');
                });
            }
        },
        update: function update() {
            var _this = this;

            this.loading = true;
            axios.put('/prototype/accounting/general-ledger/chart-of-accounts/account/' + this.accountData.id, { account: this.accountData, parent: this.parentAccount, category: this.accountCategory }).then(function () {
                Event.$emit('refresh-gl-coa-accounts');
                Event.$emit('clear-selected');
                _this.accountData = {};
                _this.loading = false;
            });
        },
        remove: function remove() {
            var _this2 = this;

            this.loading = true;
            axios.post('/prototype/accounting/general-ledger/chart-of-accounts/account/destroy', { account: this.accountData.id }).then(function () {
                Event.$emit('refresh-gl-coa-accounts');
                Event.$emit('clear-selected');
                _this2.accountData = {};
                _this2.loading = false;
            });
        }
    },

    computed: {
        filteredAccounts: function filteredAccounts() {
            if (this.allAccounts.length) {
                return this.allAccounts.map(function (account) {
                    return {
                        id: account.id, display: account.number + ' - ' + account.name
                    };
                });
            }
        },
        filteredCategories: function filteredCategories() {
            return this.categories.map(function (category) {
                return {
                    id: category.id, display: category.number + ' - ' + category.name
                };
            });
        },
        canMoveRight: function canMoveRight(account) {
            Event.$emit('get-accounts', this.category);
            // find parent

            if (this.allAccounts.length) {
                var parent = this.allAccounts.find(function (all) {
                    return account.parent_id === all.id;
                });
            }

            if (parent.children.length > 1) {
                return true;
            } else {
                return false;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/general-ledger/settings/chart-of-accounts/SingleAccount.vue
// module id = l0w5
// module chunks = 0 1